/**
 * values to be used on 'name' form field for setting 'format'
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const NAME_FORMATS = {
  NO_TITLE:    'notitle',
  NO_TITLE_F:  'notitle_f',
  NO_TITLE_LF: 'notitle_lf',
  TITLE:       'title',
  TITLE_LF:    'title_lf',
};

const NAME_FORMATS_LIST = [
  { text: locale('First'), value: NAME_FORMATS.NO_TITLE_F },
  { text: locale('First/Last'), value: NAME_FORMATS.NO_TITLE },
  { text: locale('Last/First'), value: NAME_FORMATS.NO_TITLE_LF },
  { text: locale('Title/First/Last'), value: NAME_FORMATS.TITLE },
  { text: locale('Title/Last/First'), value: NAME_FORMATS.TITLE_LF },
];

const NAME_FORMATS_ALL = _.map(NAME_FORMATS_LIST, 'value');

export { NAME_FORMATS, NAME_FORMATS_LIST, NAME_FORMATS_ALL };

export default NAME_FORMATS;
